import { Grid2 } from "@mui/material";
import { FC } from "react";
import Button from "../../components/atoms/Button";
// import ContactCard from "./ContactCard";
// import { useSelector } from "react-redux";
// import { RootState } from "../../app/store";

interface SuccessPageProps {
  openContactModal: () => void;
  fontClass?: string;
  stylingType?: "events_styling" | "booking_proposal_styling";
}

const SuccessPage: FC<SuccessPageProps> = ({
  openContactModal,
  fontClass,
  stylingType = "events_styling",
}) => {
  // const { proposalSettings } = useSelector(
  //   (state: RootState) => state.proposal
  // );

  return (
    <Grid2
      width={"100%"}
      container
      spacing={4}
      justifyContent={"center"}
      alignItems={"center"}
      className={`${fontClass || "font-roboto"}`}
    >
      <Grid2 size={{ md: 3, xs: 10 }}>
        {/* <div className="flex flex-col gap-6 lg:px-0 sm:px-4">
          <ContactCard proposalSettings={proposalSettings} />
        </div> */}
      </Grid2>
      <Grid2 size={{ md: 6, xs: 10 }}>
        <div
          className={`flex flex-col gap-6 p-8 border-2 border-[#BF5934] bg-white ${fontClass || "font-roboto"}`}
        >
          <div
            className={` text-2xl font-semibold flex justify-center ${fontClass || "font-roboto"}`}
          >
            {globalThis.translate.em.proposal.success_page.title}
          </div>
          <div className="h-[1px] bg-gray-300" />
          <div
            className={` font-normal text-[16px] ${fontClass || "font-roboto"}`}
          >
            {globalThis.translate.em.proposal.success_page.description}
          </div>
          <div className="flex flex-col gap-2">
            <div
              className={` font-semibold text-lg ${fontClass || "font-roboto"}`}
            >
              {globalThis.translate.em.proposal.success_page.contact.title}
            </div>
            <div
              className={` font-normal text-sm ${fontClass || "font-roboto"}`}
            >
              {globalThis.translate.em.proposal.success_page.contact.subtitle}
            </div>
          </div>
          <div className="w-full flex justify-center">
            <Button
              onClick={() => openContactModal()}
              className={`h-16 w-40 border-2 mt-8 bg-white border-[#BF5934] rounded text-[#BF5934]  text-[18px] ${fontClass || "font-roboto"}`}
              stylingType={stylingType}
            >
              {globalThis.translate.em.proposal.success_page.contact.button}
            </Button>
          </div>
        </div>
      </Grid2>
      <Grid2 size={{ md: 3, xs: 10 }}></Grid2>
    </Grid2>
  );
};

export default SuccessPage;
